/* ============================
   Allowed Domains Validators
   ============================ */

export const loadAllowedDomains = () =>
    (process.env.REACT_APP_ALLOWED_DOMAINS || "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);

export const isAllowedScannedUrl = (scannedText, allowedList) => {
    if (!scannedText || !allowedList?.length) return false;

    let parsed;
    try {
        parsed = new URL(scannedText);
    } catch {
        return false;
    }

    const { hostname, origin } = parsed;

    return allowedList.some((entry) => {
        if (/^https?:\/\//i.test(entry)) {
            try {
                return new URL(entry).origin === origin;
            } catch {
                return false;
            }
        }
        return hostname === entry || hostname.endsWith(`.${entry}`);
    });
};
